/** Customer billing, distinct from the owner's InControl subscription. */
export const CUSTOMER_BILLING_PATH = "/flows/billing";
export const CUSTOMER_BILLING_SETUP_HREF = `${CUSTOMER_BILLING_PATH}?tab=setup`;

/** Preserve callback feedback while consuming retired Settings destinations. */
export function customerBillingSetupHref(search = ""): string {
  const params = new URLSearchParams(search);
  params.delete("settings");
  params.delete("settingsTab");
  params.set("tab", "setup");
  return `${CUSTOMER_BILLING_PATH}?${params.toString()}`;
}
